import type { LucideIcon } from "lucide-react";
import {
  MapPin,
  Globe,
  ShoppingCart,
  Sparkles,
  Code2,
  Store,
  PackageSearch,
  Star,
  Link2,
  Megaphone,
  ShieldCheck,
} from "lucide-react";

export interface ServiceItem {
  title: string;
  path: string;
  subItems?: ServiceItem[];
  badge?: string;
  description?: string;
  icon?: LucideIcon;
}

export interface ServiceGroup {
  title: string;
  services: ServiceItem[];
}

export const navigationConfig: {
  seoServices: ServiceGroup;
  otherServices: ServiceGroup;
  seoTools: ServiceGroup;
} = {
  seoServices: {
    title: "Servicios SEO con IA",
    services: [
      {
        title: "SEO Local potenciado con IA",
        path: "/servicios/seo-local-ia",
        icon: MapPin,
        description: "Google Maps y búsquedas locales. Exclusividad por sector y zona.",
        subItems: [
          { title: "SEO Local Madrid", path: "/servicios/seo-local/madrid" },
          { title: "SEO Local Toledo", path: "/servicios/seo-local/toledo" },
          { title: "SEO Local Guadalajara", path: "/servicios/seo-local/guadalajara" },
          { title: "Consulta tu zona", path: "/zonas-exclusivas" },
        ]
      },
      {
        title: "SEO Web potenciado con IA",
        path: "/servicios/seo-web-ia",
        icon: Globe,
        description: "Arquitectura, contenido y autoridad para sectores competidos.",
        subItems: [
          { title: "SEO Web Madrid", path: "/servicios/seo-web/madrid" },
          { title: "SEO Web Toledo", path: "/servicios/seo-web/toledo" },
          { title: "SEO Web Guadalajara", path: "/servicios/seo-web/guadalajara" },
          { title: "Consulta tu zona", path: "/zonas-exclusivas" },
        ]
      },
      {
        title: "SEO para Ecommerce potenciado con IA",
        path: "/servicios/seo-ecommerce-ia",
        icon: ShoppingCart,
        description: "Catálogos, fichas y feeds optimizados para vender más.",
        subItems: [
          { title: "SEO eCommerce Madrid", path: "/servicios/seo-ecommerce/madrid" },
          { title: "SEO eCommerce Toledo", path: "/servicios/seo-ecommerce/toledo" },
          { title: "SEO eCommerce Guadalajara", path: "/servicios/seo-ecommerce/guadalajara" },
          { title: "Consulta tu zona", path: "/zonas-exclusivas" },
        ]
      },
      {
        title: "GEO + SEO 360",
        path: "/servicios/geo-seo-360",
        badge: "Nuevo",
        icon: Sparkles,
        description: "Visibilidad en ChatGPT, Gemini y AI Overviews.",
      },
      {
        title: "Integración de IA en el SEO",
        path: "/integracion-ia-seo",
        badge: "Nuevo",
        icon: Sparkles,
        description: "Casos reales que aparecen en respuestas de IA.",
      },
    ],
  },
  otherServices: {
    title: "Más servicios",
    services: [
      { title: "Creación WEB con React", path: "/servicios/creacion-web-react", icon: Code2, description: "Webs ultrarrápidas, carga en 0,3s." },
      { title: "Creación Ecommerce con Shopify", path: "/servicios/creacion-ecommerce-shopify", icon: Store, description: "Tiendas premium listas para escalar." },
      { title: "Google Merchant Center con IA", path: "/servicios/google-merchant-ia", icon: PackageSearch, description: "Feeds limpios y aprobados." },
      { title: "Gestión de reseñas con IA", path: "/servicios/gestion-resenas-ia", icon: Star, description: "Reputación local bajo control." },
      { title: "Link Building Inteligente", path: "/servicios/link-building-inteligente", icon: Link2, description: "Autoridad real, sin granjas de enlaces." },
      { title: "Publicidad SEM con IA", path: "/servicios/publicidad-sem-ia", icon: Megaphone, description: "Campañas rentables desde el primer mes." },
    ],
  },
  seoTools: {
    title: "Más",
    services: [
      { title: "Zonas Exclusivas", path: "/zonas-exclusivas", icon: ShieldCheck, description: "Comprueba si tu zona sigue libre." },
    ],
  },
};
